/**
 * A function that returns the last four digits of a string, often an account number or similar.
 * Can also be passed a prefix as a second argument like '...' or '?'
 *
 * @example
 * getLastFour('123456789', '...')
 * // => '...6789'
 *
 * * getLastFour('123456789')
 * // => '6789'
 */
export var getLastFour = function (string, prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (!string)
        return '';
    var str = string.toString(); // in case a num is passed
    return "" + prefix + str.slice(-4);
};
/**
 * A function that converts a string to title case.
 * If the string is more than one word, each word's first letter is capitalized.
 *
 * @example
 * toTitleCase('javascript')
 * // => 'Javascript'
 *
 * toTitleCase('javascript and typescript')
 * // => 'Javascript And Typescript'
 */
export function toTitleCase(value) {
    var words = value.split(' ');
    var titled = words.map(function (word) {
        return word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase();
    });
    return titled.join(' ');
}
/**
 * A function that converts a string to kebab case.
 *
 * @example
 * toKebabCase('fooBarBaz')   // => foo-bar-baz
 * toKebabCase('FooBarBaz')   // => foo-bar-baz
 * toKebabCase('foo_bar+Baz') // => foo-bar-baz
 * toKebabCase('foo bar baz') // => foo-bar-baz
 */
export function toKebabCase(value) {
    return value
        .trim()
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[^a-zA-Z0-9-]+/g, '-')
        .toLowerCase();
}
/**
 * A function that converts a string to camel case.
 *
 * @example
 * toCamelCase('fooBarBaz')   // => fooBarBaz
 * toCamelCase('FooBarBaz')   // => fooBarBaz
 * toCamelCase('foo_bar+Baz') // => fooBarBaz
 * toCamelCase('foo bar baz') // => fooBarBaz
 */
export function toCamelCase(value) {
    return value
        .trim()
        .split(/[^[a-zA-Z0-9]/g)
        .reduce(function (acc, subStr) {
        if (!subStr)
            return acc;
        var char0 = subStr.slice(0, 1);
        var initial = acc.length ? char0.toUpperCase() : char0.toLowerCase();
        var rest = subStr.slice(1);
        return acc + initial + rest;
    }, '');
}
//# sourceMappingURL=string.js.map